package fr.manyverse.app.domain.model

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable
import kotlinx.serialization.Transient
import kotlin.time.Instant

@Serializable
data class Character(
    @SerialName("id")
    val id: String,

    @SerialName("universe_id")
    val universeId: String,

    @SerialName("user_id")
    val userId: String,

    @SerialName("name")
    val name: String,

    @SerialName("story")
    val story: String,

    @SerialName("image_url")
    val imageUrl: String? = null,

    @Transient
    val signedImageUrl: String? = null,

    @SerialName("created_at")
    val createdAt: Instant,

    @SerialName("updated_at")
    val updatedAt: Instant,

    @SerialName("sheet")
    val sheet: CharacterSheet = CharacterSheet()
)
